import moment from 'moment';

export const getNow = () => {
  return new Date().toISOString().slice(0, 10);
};

export const getNdaysAgo = (n) => {
  return new Date(new Date().setDate(new Date().getDate() - 7))
    .toISOString()
    .slice(0, 10);
};

export const formatDateTime = (date, format) => {
  return moment(date).utcOffset(0).format(format);
};

export const openExternalLink = (href) => {
  window.open(href);
  // try {
  //   window?.invokeCSharpAction(`openLink;${href}`);
  // } catch (e) {
  //   console.log(e);
  // }
};

export const sendQRMessage = (userId) => {
  try {
    window?.invokeCSharpAction(`qrcode;${userId}`);
  } catch (e) {
    console.log(e);
  }
};
